module.exports = __webpack_public_path__ + "img/nevs_level_C.34fe69a0.png";